// 今日看瓜 首页静态内容数据（纯展示，不做接口请求）

export const navLinks = [
  { label: '实时热点榜', href: '#rank' },
  { label: '今日快讯', href: '#feed' },
  { label: '看瓜栏目', href: '#channels' },
  { label: '焦点专题', href: '#special' },
  { label: '常见问题', href: '#faq' },
];

export const tickerItems = [
  '今晚 20 点 明星红毯直播开启，谁是最佳造型见分晓',
  '新剧《雾都回声》上线 6 小时播放量破千万',
  '国家队公布新一期大名单，年轻小将首次入选',
  '科技圈再迎发布：折叠屏新旗舰今晚亮相',
  '某平台年度盛典官宣明星阵容，话题热度冲上榜首',
  '民生新规明起实施，这 3 个变化与你息息相关',
  '爆款综艺《星夜营》第七期花絮释出引热议',
  '知名品牌新品首发，线下门店排起长队',
];

export const heroLead = {
  kicker: '今日头瓜 · 全网热议',
  title: '红毯夜话：谁才是今晚热搜流量王',
  desc: '盛典直播落幕，造型、金句、名场面接连登上话题榜。我们帮你把分散在各平台的热搜瓜聚在一起，看看这一夜到底谁主沉浮。',
  tag: '热 度 99.8°',
  img: 'https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20photograph%20of%20a%20bright%20red%20carpet%20press%20event%20at%20night%2C%20silhouettes%20of%20media%20photographers%20holding%20cameras%20facing%20warm%20amber%20stage%20spotlights%2C%20bokeh%20crowd%20in%20background%2C%20cinematic%20warm%20tones%2C%20clean%20dynamic%20composition%20with%20soft%20golden%20lighting&width=1600&height=900&seq=cover-hero-01&orientation=landscape',
};

export const heroSide = [
  {
    title: '手机弹窗刷屏的今夜，大家在聊什么',
    desc: '同一时间，多平台热搜几乎同步更替，快节奏吃瓜指南来了。',
    img: 'https://readdy.ai/api/search-image?query=Smartphone%20on%20wooden%20desk%20glowing%20with%20breaking%20news%20notification%20cards%20at%20night%2C%20warm%20desk%20lamp%20light%2C%20shallow%20depth%20of%20field%2C%20cozy%20editorial%20photography%2C%20warm%20golden%20tones%20and%20soft%20shadows&width=800&height=560&seq=cover-hero-02&orientation=landscape',
  },
  {
    title: '竞技之夜：一场加时赛燃爆全场',
    desc: '从胶着到绝杀，今晚的每一个瞬间都被截成表情包。',
    img: 'https://readdy.ai/api/search-image?query=Large%20stadium%20crowd%20cheering%20wildly%20under%20warm%20floodlights%20during%20a%20sports%20game%2C%20arena%20atmosphere%20with%20confetti%20and%20bokeh%20lights%2C%20dramatic%20cinematic%20warm%20color%20grade%2C%20energetic%20editorial%20sports%20photography&width=800&height=560&seq=cover-hero-03&orientation=landscape',
  },
];

export const rankItems = [
  { rank: 1, title: '年度盛典红毯名场面回顾', hot: '爆', delta: 'up', trend: 9981 },
  { rank: 2, title: '新剧《雾都回声》首播冲上榜首', hot: '热', delta: 'up', trend: 9520 },
  { rank: 3, title: '国家队新一期名单官宣', hot: '热', delta: 'same', trend: 9034 },
  { rank: 4, title: '折叠屏新旗舰发布会全程', hot: '热', delta: 'up', trend: 8710 },
  { rank: 5, title: '爆款综艺《星夜营》花絮释出', hot: '新', delta: 'new', trend: 8203 },
  { rank: 6, title: '民生新规明起落地实施', hot: '议', delta: 'up', trend: 7866 },
  { rank: 7, title: '歌手新专辑概念预告曝光', hot: '热', delta: 'down', trend: 7398 },
  { rank: 8, title: '电影口碑解禁，影迷吵翻了', hot: '议', delta: 'up', trend: 6844 },
  { rank: 9, title: '电竞总决赛门票二次开售', hot: '新', delta: 'new', trend: 6321 },
  { rank: 10, title: '品牌联名款开箱全测评', hot: '热', delta: 'down', trend: 5870 },
];

export const feedItems = [
  { time: '刚刚', title: '盛典红毯收官，多个话题冲上热搜榜首', hot: '火' },
  { time: '10 分钟前', title: '新剧《雾都回声》首播 6 小时播放破千万', hot: '火' },
  { time: '26 分钟前', title: '知名主播为直播间设备争议发声回应', hot: '' },
  { time: '41 分钟前', title: '科技旗舰发布会确认推出全新折叠形态', hot: '火' },
  { time: '55 分钟前', title: '体育总局就夏季赛程调整作出说明', hot: '' },
  { time: '1 小时前', title: '民谣歌手巡演加开三城，门票秒罄', hot: '新' },
  { time: '1 小时前', title: '多平台开始灰度上线原创内容标识', hot: '' },
  { time: '2 小时前', title: '一档观察类综艺官宣新一季嘉宾阵容', hot: '' },
  { time: '2 小时前', title: '交通出行提示：晚高峰多处路段车流较大', hot: '' },
  { time: '3 小时前', title: '顶流合体舞台彩排片段提前流出', hot: '新' },
];

export const channels = [
  {
    name: '娱乐瓜',
    desc: '红毯、盛典与圈内那些事',
    count: 186,
    img: 'https://readdy.ai/api/search-image?query=Warm%20backstage%20dressing%20room%20vanity%20with%20glowing%20mirror%20lights%20and%20soft%20golden%20glow%2C%20editorial%20behind%20the%20scenes%20photography%2C%20cinematic%20warm%20amber%20tones%2C%20elegant%20cozy%20atmosphere%2C%20clean%20composition&width=800&height=600&seq=cover-channel-01&orientation=landscape',
  },
  {
    name: '综艺场',
    desc: '热播综艺名场面与梗图',
    count: 142,
    img: 'https://readdy.ai/api/search-image?query=Colorful%20variety%20game%20show%20studio%20stage%20with%20warm%20spotlights%20and%20floating%20confetti%2C%20vibrant%20yet%20warm%20cinematic%20lighting%2C%20editorial%20entertainment%20photography%2C%20energetic%20dynamic%20composition&width=800&height=600&seq=cover-channel-02&orientation=landscape',
  },
  {
    name: '剧集热',
    desc: '新剧首播、剧透与口碑',
    count: 121,
    img: 'https://readdy.ai/api/search-image?query=Cozy%20cinema%20screening%20room%20with%20rows%20of%20empty%20seats%20bathed%20in%20warm%20golden%20projector%20glow%20from%20the%20screen%2C%20atmospheric%20editorial%20photography%2C%20cinematic%20warm%20tone%2C%20dramatic%20soft%20light&width=800&height=600&seq=cover-channel-03&orientation=landscape',
  },
  {
    name: '体育榜',
    desc: '赛场内外、转会与大名单',
    count: 168,
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20basketball%20arena%20action%20under%20warm%20floodlights%20with%20player%20silhouette%20in%20mid-air%2C%20crowd%20bokeh%2C%20cinematic%20sports%20editorial%20photography%2C%20warm%20golden%20and%20amber%20tones&width=800&height=600&seq=cover-channel-04&orientation=landscape',
  },
  {
    name: '科技派',
    desc: '新机、AI 与数码圈头条',
    count: 97,
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20gadgets%20and%20smartphone%20on%20a%20desk%20with%20soft%20warm%20holographic%20glow%20and%20golden%20light%2C%20premium%20tech%20editorial%20photography%2C%20clean%20minimal%20warm%20composition%2C%20shallow%20depth%20of%20field&width=800&height=600&seq=cover-channel-05&orientation=landscape',
  },
  {
    name: '民生汇',
    desc: '政策变化与身边大小事',
    count: 133,
    img: 'https://readdy.ai/api/search-image?query=Bustling%20city%20pedestrian%20crossing%20at%20golden%20hour%2C%20silhouettes%20of%20people%20walking%2C%20warm%20sunset%20light%20and%20city%20lights%20bokeh%2C%20editorial%20documentary%20photography%2C%20warm%20cinematic%20color%20grade&width=800&height=600&seq=cover-channel-06&orientation=landscape',
  },
];

export const specials = [
  {
    kicker: '焦点专题 01',
    title: '一场盛典，如何让全网同时刷屏',
    body: '当所有平台在同一晚被同一批关键词占领，我们试着拆解这波热度从何而来：谁抛出话题、谁下场回应、围观者又在找什么。从弹幕到二次创作，流量如何在几小时内滚成雪球。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20newsroom%20wall%20of%20multiple%20monitors%20showing%20varied%20screens%20and%20charts%2C%20warm%20interior%20lighting%2C%20editorial%20photojournalism%20photography%2C%20deep%20warm%20tones%2C%20clean%20organized%20atmosphere&width=1400&height=900&seq=cover-special-01&orientation=landscape',
  },
  {
    kicker: '焦点专题 02',
    title: '吃瓜也要有底线：我们如何筛选信源',
    body: '信息越碎，越要较真。今日看瓜从公开信源出发，优先采用官方与多方交叉信息，标注话题发酵阶段，帮你更冷静地判断正在发生的事。',
    img: 'https://readdy.ai/api/search-image?query=Two%20microphones%20on%20a%20broadcast%20studio%20stage%20with%20warm%20red%20curtain%20background%2C%20soft%20golden%20studio%20lighting%2C%20editorial%20journalism%20photography%2C%20cinematic%20warm%20tones%2C%20clean%20focused%20composition&width=1400&height=900&seq=cover-special-02&orientation=landscape',
  },
];

export const searches = [
  '红毯最佳造型', '雾都回声 更新', '新一季综艺', '折叠屏 价格',
  '加时赛 绝杀', '民谣 巡演加场', '新专辑 预告', '联名 开箱',
  '原创内容标识', '夏日赛程', '观察类综艺', '顶流 舞台',
];

export const faqs = [
  {
    q: '今日看瓜到底是什么？',
    a: '它是一个聚合今天最新爆料与热门话题的入口型信息站。我们把分散在各平台的热搜、快讯和话题按时间聚到同一页，让你打开即知今天都在聊什么。',
  },
  {
    q: '内容来源可靠吗？怎么保证客观？',
    a: '本站只做公开信息的汇总与转载，优先采用官方发布和多方交叉信源，并尽可能标注话题所处的发酵阶段。原创观察会明确区分于转载内容，不做无根据的猜测定性。',
  },
  {
    q: '热点榜多久更新一次？',
    a: '页面顶部设有实时更新条，热点榜与快讯流均按滚动节奏刷新。你看到即是最新的一批，旧内容会随时间下沉，方便你把注意力留给当前最值得关注的事件。',
  },
  {
    q: '浏览是否收费？需要登录吗？',
    a: '完全免费、无需注册即可浏览全部内容。部分按钮如「关注」「分享」仅作为功能展示，暂不接入任何账号或支付流程。',
  },
  {
    q: '遇到不实或侵权内容怎么办？',
    a: '欢迎通过页面底部的联系入口反馈。核实后会第一时间下架并更正，同时保留争议信源说明，帮助你判断信息完整度。',
  },
  {
    q: '为什么我所在平台的热搜没上榜？',
    a: '榜单以跨平台讨论热度与发酵速度为参考，不同算法侧重会带来差异。如果某话题正在你所在的小圈子高热，可切换到对应栏目查看更细的讨论。',
  },
];

export const trustStats = [
  { num: '24/7', label: '滚动刷新' },
  { num: '6+', label: '内容栏目' },
  { num: '1000+', label: '当日收录' },
  { num: '0', label: '注册门槛' },
];